// import AMapLoader from "@amap/amap-jsapi-loader";
import config from "@/config/index";

/**
 * 初始化高德地图，将高德地图挂载到Vue上
 * @param {} Vue
 */
export const install = (Vue) => {
    // AMapLoader.load({
    //     key: config.AMAP_KEY, // key
    //     plugins: ["AMap.Geocoder", "AMap.Geolocation", "Map3D", "CitySearch", "AMap.PlaceSearch", "AMap.AutoComplete"], // 插件
    // })
    //     .then((amap, b) => {
    //         Vue.prototype.$Amap = amap;
    //     })
    //     .catch((err) => {
    //         throw new Error("加载高德地图失败：" + err);
    //     });
};

/**
 * 初始化地图
 */
// 需要通过apply更改this指向，apply改不了this指向所以这里不用
export function initMap() {
    if (this.$Amap) {
        this.map = new this.$Amap.Map("container", {
            zoom: this.mapSize, // 级别
            resizeEnable: true,

            center: new AMap.LngLat(118.915804 + "", 25.120399 + ""),
        });
        setPosition.apply(this);
        clearInterval(this.timer);
    } else {
        this.timer = setInterval(this.initMap, 1000);
    }
}

/**
 * 获取当前定位
 */
function setPosition() {
    let that = this;
    this.map.clearMap();
    let options = {
        showButton: false, // 是否显示定位按钮
        // 'buttonPosition': 'LB',//定位按钮的位置
        /* LT LB RT RB */
        // 'buttonOffset': new AMap.Pixel(10, 20),//定位按钮距离对应角落的距离
        showMarker: true, // 是否显示定位点
        showCircle: false, // 是否显示定位精度圈
    };

    this.map.plugin(["AMap.Geolocation"], function () {
        let geolocation = new that.$Amap.Geolocation(options);
        that.map.addControl(geolocation);
        geolocation.getCurrentPosition(function (status, result) {
            if (status == "complete") {
                console.log(result);
                that.$store.commit("setLocation", result.position); // 将当前location存起来
                that.userLocation.lng = result.position.lng;
                that.userLocation.lat = result.position.lat;
                setPositionWithPoint.apply(that, result.position);
            } else {
                // 失败提供默认
                let address = {
                    position: {
                        lng: 118.915804,
                        lat: 25.120399,
                    },
                };
                setPositionWithPoint.apply(that, address.position);
                that.$toast("定位获取失败");
            }
        });
    });
}

/**
 * 添加半径范围、当前位置
 */
function setPositionWithPoint(p) {
    console.log(this);
    // 获取停车场数据
    let that = this;
    // 当前位置
    let myPosition = new AMap.Marker({
        map: that.map,
        offset: new AMap.Pixel(-7, -28),
        content: '<div class="location-point"></div>',
        position: new AMap.LngLat(p.lng + "", p.lat + ""),
    });
    // 半径圆
    let circle = new AMap.Circle({
        map: that.map,
        radius: that.userLocation.radius * 1000,
        strokeColor: "#0093FF",
        noSelect: true,
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: "#02B0FF",
        fillOpacity: 0.25,
        center: new AMap.LngLat(p.lng + "", p.lat + ""),
    });

    getParking.apply(this, p);
    setTimeout(() => {
        this.map.setZoomAndCenter(this.mapSize, [p.lng, p.lat]);
    }, 1);
}

/**
 *根据用户所在经纬度获取停车场
 */
function getParking(point) {
    console.log(this);
    let that = this;
    let obj = {
        lat: point.lat,
        lng: point.lng,
        radius: this.userLocation.radius,
    };
    getParkDistribute(obj).then((res) => {
        if (res.code == 200) {
            that.parkingLotList = res.data.rows;
            that.parkingList = res.data.rows;
            let points = res.data.rows;

            if (points.length > 0) {
                // 判断当前是有选择某个车场
                let obj = that.$route.params;
                if (Object.keys(obj).length > 0 && obj.type == "parking") {
                    that.showParkingLotDetail = true;
                    that.detailData = obj;
                }
                that.showParkingLot = true; // 弹出底部车场
                that.addPointToMap(points);
            }
        }
    });
}
